import { useListIntegrations } from '~/domains/account/hooks/use-list-integrations.hook'
import { DialogHeader, DialogTitle } from '@cocoonspace/ui/components/dialog'
import { useLingui } from '@lingui/react/macro'

import { IntegrationsList } from '~/domains/account/components/integrations/integrations-list'
import { PrevBtn } from './prev-btn'
import { ValidateBtn } from './validate-btn'

export const StepCalendarSync = () => {
	const { t } = useLingui()

	const { data: userIntegrations } = useListIntegrations()

	const hasGoogleCalendar = userIntegrations?.google?.connected
	const hasMicrosoftOutlook = userIntegrations?.outlook?.connected
	const hasIntegration = hasGoogleCalendar || hasMicrosoftOutlook

	return (
		<>
			<DialogHeader className='p-6 pb-0'>
				<DialogTitle>{t`Synchronisez votre calendrier`}</DialogTitle>
			</DialogHeader>

			<div className='flex flex-col gap-4 p-6'>
				<IntegrationsList />

				<div className='flex items-center gap-4'>
					<PrevBtn />
					<ValidateBtn disabled={!hasIntegration} />
				</div>
			</div>
		</>
	)
}
